export const defaultInventoryFilters = "?filter%5B%5D=state%2Cis_any_of%2Cin_process%2Cresellable%2Cinvoiced%2Cewasted";
